import { render } from "./ImageViewer.vue?vue&type=template&id=99d1f304&ts=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__